module.exports = __webpack_public_path__ + "static/media/dop-tsla.4e5efb80.svg";